/** @jsxImportSource @emotion/react */
import { useDispatch } from 'react-redux';
import { useProfileState } from '@/store/profile/hooks';
import { useTranslate } from '@/i18n/useTranslate';
import { profileActions } from '@/store/profile/slice';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@/components';

import DATA_TEST_IDS from '../dataTestIds';
import { testId } from '@/utils/testId';
import { Typography } from '@mui/material';
import { sx } from './styles';

export const AboutSystem = () => {
  const dispatch = useDispatch();
  const { aboutSystemShown } = useProfileState();
  const { t } = useTranslate('common');
  const hideAboutSystem = () => {
    dispatch(profileActions.setDisplayInfoAboutSystem(false));
  };
  return (
    <Dialog
      data-test-id={testId(DATA_TEST_IDS.fragmentsAboutSystem + '_dialog')}
      open={!!aboutSystemShown}
      size={'lg'}
      onClose={hideAboutSystem}
    >
      <DialogTitle
        onClose={hideAboutSystem}
        noContent={false}
        data-test-id={testId(
          DATA_TEST_IDS.fragmentsAboutSystem + '_dialog-title'
        )}
      >
        {t('ABOUT_SYSTEM')}
      </DialogTitle>
      <DialogContent sx={sx.dialogContent}>
        <Typography variant="string/md">
          {t('VIVICA_AND_THE_VIVICA_LOGO_ARE_')}
        </Typography>
        <Typography sx={sx.dialogContentText} variant="string/md">
          {t('THIS_PRODUCT_USES_PUBLICLY_')}
        </Typography>
      </DialogContent>
      <DialogActions sx={sx.dialogActions}>
        <Button
          variant="contained"
          color="secondary"
          onClick={hideAboutSystem}
          data-test-id={testId(DATA_TEST_IDS.frgmentsAboutSystemDialogClose)}
        >
          {t('CLOSE')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
